import classNames, {Argument} from 'classnames';
import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import styles from './NotFoundComponent.less';

const I18N = defineMessages({
  TEXT: {
    id: 'common.notFoundComponent',
    defaultMessage: 'There is no data for this page.',
    description: 'error message for not found route',
  },
});

interface OwnProps {
  className?: Argument;
  text?: string;
}

type Props = OwnProps;

export const NotFoundComponent: React.FC<Props> = (props) => {
  const {className = '', text = I18N.TEXT.id} = props;
  const translatedText = {...I18N.TEXT, id: text};
  return (
    <div className={classNames(className, styles.dlNotFoundComponent)}>
      <div className={styles.dlNotFoundComponentObject}>
        <div className={classNames('fas fa-exclamation-triangle', styles.dlNotFoundComponentIcon)} />
        <div className={styles.dlNotFoundComponentText}>
          <FormattedMessage {...translatedText} />
        </div>
      </div>
    </div>
  );
};

NotFoundComponent.displayName = 'NotFoundComponent';
